import { useParams } from "react-router-dom";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { PackageHolders } from "../../components/UnifiedSearchList/PackageHolders";

export default function PackageHoldersPage() {
  const { uuid, id } = useParams();

  return (
    <PaginationProvider>
      <ModalProvider>
        <PackageHolders uuid={uuid} fanId={id} />
      </ModalProvider>
    </PaginationProvider>
  );
}
